import { getAPI, type UserAPI } from '@sydle/ui-api';
import { type BlogPost } from '../types/blog';

export function richContentEvent(post: BlogPost): void {
  window?.stag?.('event', 'blogRichContent', {
    contentClassification: 'rich-content',
    contentCluster: post.cluster || '',
    contentLevel: post.funnelPhase,
    serviceName: post.title,
    serviceId: post._id,
    categoryName: post.category.name,
    categoryId: post.category._id,
    lang: post.lang,
  });
}

export function contentEvent(post: BlogPost): void {
  let contentClassification = 'post';
  const isLoggedIn = getAPI<UserAPI>('userAPI')?.isLoggedIn();
  if (post.isRichContent && isLoggedIn && !post.attachment) {
    // Acesso logado a conteúdo rico sem anexo:
    //  => Loga evento com se tivesse baixado um conteúdo rico
    return richContentEvent(post);
  }
  if (post.isRichContent && isLoggedIn && post.attachment) {
    // Acesso logado a conteúdo rico COM anexo:
    //  => Somente loga quando efetivamente fizer o download
    return;
  }
  if (post.isRichContent) {
    // Acesso a conteúdo rico deslogado
    //  => Loga como acesso a previa de conteúdo
    contentClassification = 'rich-content-preview';
  }

  window?.stag?.('event', 'blogContent', {
    contentClassification,
    contentCluster: post.cluster || '',
    contentLevel: post.funnelPhase,
    serviceName: post.title,
    serviceId: post._id,
    categoryName: post.category.name,
    categoryId: post.category._id,
    lang: post.lang,
  });
}

export function newsletterEvent(identifier: string): void {
  window?.stag?.('event', 'blogNewsletter', {
    consentIdentifier: identifier,
  });
}

export function suggestionEvent(identifier: string): void {
  window?.stag?.('event', 'blogPostSuggestion', {
    consentIdentifier: identifier,
  });
}

export function contentShareEvent(post: BlogPost, mediaName: string): void {
  let contentClassification = 'post';
  const isLoggedIn = getAPI<UserAPI>('userAPI')?.isLoggedIn();
  if (post.isRichContent && isLoggedIn) {
    contentClassification = 'rich-content';
  } else if (post.isRichContent) {
    contentClassification = 'rich-content-preview';
  }

  window?.stag?.('event', 'blogShare', {
    contentClassification,
    contentCluster: post.cluster || '',
    contentLevel: post.funnelPhase,
    serviceName: post.title,
    serviceId: post._id,
    categoryName: post.category.name,
    categoryId: post.category._id,
    lang: post.lang,
    mediaName,
  });
}
